export const YEAR_PREFIX = '20'
export const CREDIT_CARD_MASK = '•••• •••• •••• •••• '
